import { MatSelectConfig } from "@angular/material/select";

export const selectDefaultOptions: MatSelectConfig = {
  // the legacy select marked the selected option by colour only, without a checkmark
  hideSingleSelectionIndicator: true
};
